import { gateway } from "../../../gateway";
import { KanbanPage } from "../interfaces/kanbanPage.interface";

/**
 * Action to update a kanban page (e.g., rename)
 *
 * Backend endpoint: PATCH /kanban-pages/self/:pageUid
 * Request body: { name?: string, description?: string, order?: number }
 * Response format: { status: 200, message: "Kanban page updated", data: KanbanPage }
 */
export const updateKanbanPageAction = async (pageId: string, updates: Partial<KanbanPage>): Promise<KanbanPage> => {
  try {
    if (!pageId) {
      throw new Error("Page ID is required");
    }

    // Prepare update payload - only include defined fields
    const updatePayload: any = {};
    if (updates.name !== undefined) {
      updatePayload.name = updates.name.trim();
    }
    // Note: description is not in frontend interface but backend supports it
    if ((updates as any).description !== undefined) {
      updatePayload.description = (updates as any).description;
    }
    if (updates.order !== undefined) {
      updatePayload.order = updates.order;
    }

    const response = await gateway.patch(`/kanban-pages/self/${pageId}`, updatePayload);

    // Backend returns { status, message, data } where data is the updated page
    const page = response.data?.data || response.data;

    if (!page) {
      throw new Error("Invalid response from server");
    }

    return page;
  } catch (error: any) {
    console.error("Error updating kanban page:", error);
    // Extract error message from backend response
    const errorMessage = error?.response?.data?.message || error?.message || "Failed to update kanban page";
    throw new Error(errorMessage);
  }
};
